export default __webpack_public_path__ + "static/media/Empathy intro.28be2957.jpg";